import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
import { images } from '../../data/images';
import { usps } from '../../data/navigation';
const ease = [0.23, 1, 0.32, 1] as const;
const lines = ['Pure Marokkaanse', 'verzorging.'];
export function HomeHero() {
  const reduce = useReducedMotion();
  const {
    scrollY
  } = useScroll();
  const scale = useTransform(scrollY, [0, 800], [1, reduce ? 1 : 1.1]);
  return <section className="relative h-[100svh] min-h-[640px] w-full overflow-hidden bg-ink" data-id="element-41" data-mp="31sewv79xt2jp">
      <motion.img src={images.hero} alt="Vrouw met een natuurlijk verzorgde huid in warm daglicht" style={{
      scale
    }} className="absolute inset-0 h-full w-full object-cover object-[50%_28%]" data-id="element-42" data-mp="2n3sib7s4wetj" />
      <div className="absolute inset-0 bg-ink/40" aria-hidden="true" data-id="element-43" data-mp="3fr65wf9xzy0z" />

      <div className="relative mx-auto flex h-full max-w-7xl flex-col justify-end px-5 pb-6 lg:px-8 lg:pb-8" data-id="element-44" data-mp="3klaef2yuwe46">
        <div className="grid items-end gap-8 lg:grid-cols-12" data-id="element-45" data-mp="ovh5z1yynj4n">
          <div className="lg:col-span-8" data-id="element-46" data-mp="jx74yaqk1ob4">
            <motion.p initial={reduce ? false : {
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.3,
            delay: 0.1
          }} className="flex items-center gap-2 text-sm text-white/85" data-id="element-47" data-mp="ju1jr6l1r6ko">
              <span className="flex" aria-hidden="true" data-id="element-48" data-mp="17kfbevzpz3eq">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-blush text-blush" strokeWidth={0} data-id="element-49" data-mp="12mdt4da4b84b" data-mpi={i} />)}
              </span>
              4,8 uit 3.100+ reviews
            </motion.p>
            <h1 className="mt-4 text-[clamp(3rem,8.5vw,7.75rem)] font-semibold leading-[0.9] tracking-display text-white" data-id="element-50" data-mp="1clbh9f3mszms">
              {lines.map((l, i) => <span key={l} className="block overflow-hidden pb-[0.06em]" data-id="element-51" data-mp="3ecy9tl3692ld" data-mpi={i}>
                  <motion.span className={`block ${i === 1 ? 'text-blush' : ''}`} initial={reduce ? false : {
                y: '105%'
              }} animate={{
                y: 0
              }} transition={{
                duration: 0.3,
                delay: 0.12 + i * 0.07,
                ease
              }} data-id="element-52" data-mp="1hbsdd41tow6e">
                    {l}
                  </motion.span>
                </span>)}
            </h1>
            <motion.div initial={reduce ? false : {
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.3,
            ease
          }} className="mt-8 flex flex-wrap gap-3" data-id="element-53" data-mp="20ay0obu0vxu5">
              <Link to="/collectie/bestsellers" className="group inline-flex h-14 items-center gap-2 whitespace-nowrap rounded-full bg-white px-7 text-base font-medium text-ink transition-colors duration-150 hover:bg-blush" data-id="element-54" data-mp="2a2anuq4vlztu">
                Shop bestsellers
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-55" data-mp="2nxmjczquvubt" />
              </Link>
              <Link to="/collectie/voor-hem" className="inline-flex h-14 items-center whitespace-nowrap rounded-full border border-white/40 px-7 text-base font-medium text-white transition-colors duration-150 hover:border-white hover:bg-white/10" data-id="element-56" data-mp="8asfdzrmzbmv">
                Voor hem
              </Link>
            </motion.div>
          </div>

          <motion.div initial={reduce ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.38,
          ease
        }} className="hidden lg:col-span-4 lg:block" data-id="element-57" data-mp="r1s0gpw0g1av">
            <Link to="/product/hammam-ritueel-set" className="group flex items-center gap-4 rounded-2xl bg-white/95 p-3 pr-5 text-ink backdrop-blur transition-transform duration-200 hover:-translate-y-0.5" data-id="element-58" data-mp="hbgihzfhrrkz">
              <img src={images.giftset} alt="" className="h-20 w-20 rounded-xl bg-surface object-cover" data-id="element-59" data-mp="uhuvvheg7ock" />
              <span className="flex-1" data-id="element-60" data-mp="ykhhv1ofuf1u">
                <span className="block text-xs font-medium text-clay" data-id="element-61" data-mp="ylj0psbp45u4">Meest gekocht</span>
                <span className="block font-semibold" data-id="element-62" data-mp="klritgi265au">Hammam Ritueel Set</span>
                <span className="block text-sm" data-id="element-63" data-mp="pkck7j91qv0v">
                  <span className="font-semibold" data-id="element-64" data-mp="pl4hcyial0t9">€ 59,95</span> <span className="text-muted line-through" data-id="element-65" data-mp="1d8m42fmp98pd">€ 69,75</span>
                </span>
              </span>
              <span className="grid h-10 w-10 place-items-center rounded-full bg-ink text-white transition-colors duration-150 group-hover:bg-clay" data-id="element-66" data-mp="1i6nl6v0kexy7">
                <ArrowRightIcon className="h-4 w-4" data-id="element-67" data-mp="18i5n4ljo74y9" />
              </span>
            </Link>
          </motion.div>
        </div>

        <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-2 border-t border-white/20 pt-5 text-sm text-white/80" data-id="element-68" data-mp="1w7gejcf4rmzq">
          {usps.map(u => <li key={u} className="flex items-center gap-2 whitespace-nowrap" data-id="element-69" data-mp="210jbzvn13gl7">
              <span className="h-1 w-1 rounded-full bg-blush" aria-hidden="true" data-id="element-70" data-mp="3lnan912rxc8o" />
              {u}
            </li>)}
        </ul>
      </div>
    </section>;
}